import { useParams } from 'react-router-dom'
import { AxiosError } from 'axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { DeleteButton } from '@ui/actions'
import { useSnackbar } from '@ui/snackbar'
import {
  getModel,
  getProjectFiles,
  getStiffeningIntervals,
  getStiffeningProposal,
  getTensileTransmissionGraph,
  getVerticalTransmissionGraph,
} from '@queries'
import { deleteElements } from '@mutations'
import { buildErrorMessage, documentationRootGuid } from 'src/constants'

interface Props {
  selectedElements: string[]
  resetSelected: () => void
}

const MultiDelete = ({ selectedElements, resetSelected }: Props) => {
  const { projectId } = useParams<{ projectId: string }>()
  const { enqueueSnackbar } = useSnackbar()
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async () => {
      return await deleteElements.request(projectId, selectedElements)
    },
    onSuccess: async () => {
      resetSelected()
      await Promise.all([
        queryClient.invalidateQueries(getModel.getKey(projectId)),
        queryClient.invalidateQueries(getVerticalTransmissionGraph.getKey(projectId)),
        queryClient.invalidateQueries(getModel.getKey(projectId)),
        queryClient.invalidateQueries(getStiffeningProposal.getKey(projectId)),
        queryClient.invalidateQueries(getStiffeningIntervals.getKey(projectId)),
        queryClient.invalidateQueries(getTensileTransmissionGraph.getKey(projectId)),
        queryClient.invalidateQueries(getProjectFiles.getKey(projectId, documentationRootGuid)),
      ])
      enqueueSnackbar('Elemente gelöscht', { variant: 'success' })
    },
    onError: (error: AxiosError) => {
      enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Löschen der Elemente'), {
        variant: 'error',
      })
    },
  })

  return (
    <DeleteButton
      loading={isLoading}
      onClick={() => mutateAsync()}
      size="small"
      sx={{ paddingX: 1, paddingY: 0.5 }}
    >
      löschen
    </DeleteButton>
  )
}

export default MultiDelete
